import { ChangeDetectionStrategy, Component, DOCUMENT, HostListener, inject } from '@angular/core';
import { CookieBannerComponent } from "../../../custom/cookie-consent/cookie-banner.component";


@Component({
    standalone: true,
    imports: [CookieBannerComponent],
    selector: 'vsf-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutComponent {
  private document = inject(DOCUMENT);
  showScrollTop = false;
  
  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const scrollTop =
      this.document.documentElement.scrollTop ||
      this.document.body.scrollTop;

    this.showScrollTop = scrollTop > 400;
  }

  scrollToTop(): void {
    this.document.documentElement.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }
}
